import React, { useEffect, useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import SuccessIcon from './components/success-icon';
import SaveButtonIcon from './components/save-button-icon';
import { STATUSES } from './constants';

const SaveButton = ({
  status = STATUSES.normal,
  disabled = false,
  onClick = Function.prototype,
}) => {
  const [isAnimated, setIsAnimated] = useState(false);
  const [prevStatus, setPrevStatus] = useState('');
  useEffect(() => {
    if (
      (prevStatus === STATUSES.progress && status === STATUSES.success) ||
      (prevStatus === STATUSES.progress && status === STATUSES.error)
    ) {
      setIsAnimated(true);
    }

    setPrevStatus(status);
  }, [status, prevStatus]);
  const isProgress = status === STATUSES.progress;
  const isSuccess = status === STATUSES.success;
  const isError = status === STATUSES.error;
  const areSavingStatuses = isProgress || isSuccess || isError;

  const classes = classNames(`ws-ui-save-button`, {
    'ws-ui-save-button--status-progress': isProgress,
    'ws-ui-save-button--status-success': isSuccess,
    'ws-ui-save-button--status-error': isError,
  });

  return (
    <button
      className={classes}
      disabled={disabled}
      onClick={onClick}
      {...(areSavingStatuses && { tabIndex: -1 })}
    >
      <SaveButtonIcon glyph="save" />

      {isProgress && (
        <span className="ws-ui-save-button__layer ws-ui-save-button__layer--progress">
          <SaveButtonIcon glyph="save" />
        </span>
      )}

      {isAnimated && (
        <Fragment>
          {isSuccess && (
            <Fragment>
              <span className="ws-ui-save-button__layer ws-ui-save-button__layer--progress">
                <SaveButtonIcon glyph="save" />
              </span>

              <span className="ws-ui-save-button__layer ws-ui-save-button__layer--success">
                <SuccessIcon />
              </span>
            </Fragment>
          )}
          {isError && (
            <span className=" ws-ui-save-button__layer ws-ui-save-button__layer--error">
              <SaveButtonIcon glyph="attention" />
            </span>
          )}
        </Fragment>
      )}
    </button>
  );
};

SaveButton.propTypes = {
  status: PropTypes.oneOf(Object.values(STATUSES)),
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

export default SaveButton;
